import React from "react";

import NavBar from "./Navbar";
import Hero from "./Hero";
import About from "./About";
import Feacher from "./Feachers"
import Footer from "./Footer";
import Services from "./Services";
import Portfolio from "./Portfolio";
import Testimonials from "./Testimonials";
import Team from "./Team";
import Clients from "./Clients";
import Pricing from "./Pricing";
import Contact from "./Contact";


const App = () =>{
  return(
    <div>
     <NavBar />
     <Hero />
     <About />
     <Feacher />
     <Services />
     <Portfolio />
     <Team/>
     <Clients />
     <Pricing />
     <Testimonials />
      <Contact />
     <Footer />
   
    </div>
  );
}

export default App;